import {
  AcceptOrderApi,
  AuthApi,
  AuthorityApi,
  BatchAvLibraryMarcRegApi,
  BatchCollectionMgmtBibColBulkRemovalApi,
  BatchCollectionMgmtBibliographyBulkRemovalApi,
  BatchCollectionMgmtCollectionBulkRemovalApi,
  BatchCollectionMgmtListByCollectionApi,
  BatchCollectionMgmtRemovalListApi,
  BatchFileUploadApi,
  BatchForcedReturnApi,
  BatchLendCollectionListApi,
  BatchLendDbUpdateApi,
  BatchLendInfoExtractApi,
  BatchMarcRegFileUploadApi,
  BatchNhkMarcRegApi,
  BatchNrcMarcCatalogRegApi,
  BatchNrcMarcContentRegApi,
  BatchOrderAcceptBreakingNewsApi,
  BatchOrderAcceptLedgerApi,
  BatchOrderAcceptListApi,
  BatchReminderLetterApi,
  BatchReminderListApi,
  BatchReminderMailApi,
  BatchReminderPostcardApi,
  BatchReserveCancelListApi,
  BatchReserveCollectionListApi,
  BatchReserveContactMailExtractApi,
  BatchReserveContactMailSearchApi,
  BatchReserveContactMailSendApi,
  BatchReserveInfoExtractApi,
  BatchReserveInfoExtractCsvApi,
  BatchReserveReturnWaitingCollectionForwardingCandidateListApi,
  BatchOnShelfReserveListApi,
  BatchReserveUserListApi,
  BatchReturnDbUpdateApi,
  BatchReturnInfoExtractApi,
  BatchStatisticsApi,
  BatchStatisticsBestReaderApi,
  BatchStatisticsCollectionApi,
  BatchStatisticsDailyOutputApi,
  BatchStatisticsDeletePredefinedItemApi,
  BatchStatisticsLendSelectShelfApi,
  BatchStatisticsMonthlyOutputApi,
  BatchStatisticsReferenceApi,
  BatchStatisticsRegUsrApi,
  BatchStatisticsReserveApi,
  BatchStatisticsReserveBestApi,
  BatchStatisticsYearlyOutputApi,
  BatchTohanBooksOrderDataCreateApi,
  BatchTohanMarcRegApi,
  BatchTrcBooksAndAvRegApi,
  BatchUserListApi,
  BatchUserRemovalApi,
  BatchExpiredUserListApi,
  BatchDataShortageUserListApi,
  BibliographyApi,
  BibliographyContentApi,
  BibliographyRealApi,
  BibliographySetApi,
  BudgetApi,
  ClosedDayApi,
  CollectionApi,
  ConditionApi,
  ConvertShelfTypeApi,
  DataApi,
  DefaultParameterApi,
  DonorApi,
  InspectionApi,
  InterLibraryLoanApi,
  JobApi,
  LendApi,
  LogApi,
  MarcLabelApi,
  MyNoticeApi,
  NdcListApi,
  NoticeApi,
  OrderApi,
  OrderListApi,
  PatrolDayApi,
  PlaceChangeApi,
  ReferenceApi,
  ReferenceImageMasterApi,
  RemindHistoriesApi,
  ReserveApi,
  ReserveGroupApi,
  ReserveSetApi,
  ReturnHistoriesApi,
  SeparateApi,
  SlideDaysApi,
  SystemCodeAddressApi,
  SystemCodeApi,
  SystemCodeAreaApi,
  SystemCodeKeyApi,
  SystemConfigApi,
  SystemGroupApi,
  SystemOperationMenuApi,
  SystemParameterApi,
  SystemParameterKeyApi,
  SystemTopMenuApi,
  SystemUserApi,
  SystemUserLinkApi,
  TodayStatusApi,
  TraderAndDonorApi,
  TraderApi,
  UploadApi,
  UsageStatisticsApi,
  UserApi,
  BatchNotificationMailApi,
  CollectionListApi,
  SynonymGroupApi,
  SeparateDictionaryApi,
  BatchTrcAcceptMarcRegisterApi,
  BatchTrcContentDetailRegisterApi,
  BatchTrcContentDetailUpdateApi,
  BatchTrcContentDataRegisterApi,
  BatchTrcContentDataUpdateApi,
  BatchTrcAuthorityRegisterApi,
  BatchTrcAuthorityUpdateApi,
  BatchTrcBooksAndAvUpdateApi,
  BatchTrcBooksOrderDataCreateApi,
  BatchSchoolStatisticsApi,
  BatchSchoolStatisticsLendApi,
  BatchSchoolLendCollectionListApi,
  BatchSchoolUserListApi,
  BatchBibliographyCollectionExportApi,
  BatchBibliographyCollectionImportApi,
  ExternalCollaborationApi,
  BatchSchoolStatisticsAdvancementApi,
  BatchSchoolStatisticsNewStudentRegistrationApi
} from '@/api/apis'
import { Configuration } from '@/api/runtime'
import { SystemBatchMenuApi } from '@/api/apis/SystemBatchMenuApi'
import { SystemCheckApi } from '@/api/apis/SystemCheckApi'
import { BatchSchoolStatisticsBestReaderApi } from './apis/batch/BatchSchoolStatisticsBestReaderApi'

const config = new Configuration({
  basePath: '/api',
  headers: {
    Accept: 'application/json'
  }
})

export * from './apis'
export * from './models'
export * from './runtime'
export const acceptOrderApi = new AcceptOrderApi(config)
export const authApi = new AuthApi(config)
export const authorityApi = new AuthorityApi(config)
export const batchAvLibraryMarcRegApi = new BatchAvLibraryMarcRegApi(config)
export const batchCollectionMgmtBibColBulkRemovalApi = new BatchCollectionMgmtBibColBulkRemovalApi(
  config
)
export const batchCollectionMgmtBibliographyBulkRemovalApi = new BatchCollectionMgmtBibliographyBulkRemovalApi(
  config
)
export const batchCollectionMgmtCollectionBulkRemovalApi = new BatchCollectionMgmtCollectionBulkRemovalApi(
  config
)
export const batchCollectionMgmtListByCollectionApi = new BatchCollectionMgmtListByCollectionApi(
  config
)
export const batchCollectionMgmtRemovalListApi = new BatchCollectionMgmtRemovalListApi(
  config
)
export const batchFileUploadApi = new BatchFileUploadApi(config)
export const batchForcedReturnApi = new BatchForcedReturnApi(config)
export const batchLendCollectionListApi = new BatchLendCollectionListApi(config)
export const batchLendDbUpdateApi = new BatchLendDbUpdateApi(config)
export const batchLendInfoExtractApi = new BatchLendInfoExtractApi(config)
export const batchMarcRegFileUploadApi = new BatchMarcRegFileUploadApi(config)
export const batchNhkMarcRegApi = new BatchNhkMarcRegApi(config)
export const batchNotificationMailApi = new BatchNotificationMailApi(config)
export const batchNrcMarcCatalogRegApi = new BatchNrcMarcCatalogRegApi(config)
export const batchNrcMarcContentRegApi = new BatchNrcMarcContentRegApi(config)
export const batchOrderAcceptBreakingNewsApi = new BatchOrderAcceptBreakingNewsApi(
  config
)
export const batchOrderAcceptLedgerApi = new BatchOrderAcceptLedgerApi(config)
export const batchOrderAcceptListApi = new BatchOrderAcceptListApi(config)
export const batchReminderLetterApi = new BatchReminderLetterApi(config)
export const batchReminderListApi = new BatchReminderListApi(config)
export const batchReminderMailApi = new BatchReminderMailApi(config)
export const batchReminderPostcardApi = new BatchReminderPostcardApi(config)
export const batchReserveCancelListApi = new BatchReserveCancelListApi(config)
export const batchReserveCollectionListApi = new BatchReserveCollectionListApi(
  config
)
export const batchReserveContactMailExtractApi = new BatchReserveContactMailExtractApi(
  config
)
export const batchReserveContactMailSearchApi = new BatchReserveContactMailSearchApi(
  config
)
export const batchReserveContactMailSendApi = new BatchReserveContactMailSendApi(
  config
)
export const batchReserveInfoExtractApi = new BatchReserveInfoExtractApi(config)
export const batchReserveInfoExtractCsvApi = new BatchReserveInfoExtractCsvApi(
  config
)
export const batchReserveReturnWaitingCollectionForwardingCandidateListApi = new BatchReserveReturnWaitingCollectionForwardingCandidateListApi(
  config
)
export const batchOnShelfReserveListApi = new BatchOnShelfReserveListApi(config)
export const batchReserveUserListApi = new BatchReserveUserListApi(config)
export const batchReturnDbUpdateApi = new BatchReturnDbUpdateApi(config)
export const batchReturnInfoExtractApi = new BatchReturnInfoExtractApi(config)
export const batchStatisticsApi = new BatchStatisticsApi(config)
export const batchStatisticsBestReaderApi = new BatchStatisticsBestReaderApi(
  config
)
export const batchStatisticsCollectionApi = new BatchStatisticsCollectionApi(
  config
)
export const batchStatisticsDailyOutputApi = new BatchStatisticsDailyOutputApi(
  config
)
export const batchStatisticsDeletePredefinedItemApi = new BatchStatisticsDeletePredefinedItemApi(
  config
)
export const batchStatisticsLendSelectShelfApi = new BatchStatisticsLendSelectShelfApi(
  config
)
export const batchStatisticsMonthlyOutputApi = new BatchStatisticsMonthlyOutputApi(
  config
)
export const batchStatisticsReferenceApi = new BatchStatisticsReferenceApi(
  config
)
export const batchStatisticsRegUsrApi = new BatchStatisticsRegUsrApi(config)
export const batchStatisticsReserveApi = new BatchStatisticsReserveApi(config)
export const batchStatisticsReserveBestApi = new BatchStatisticsReserveBestApi(
  config
)
export const batchStatisticsYearlyOutputApi = new BatchStatisticsYearlyOutputApi(
  config
)
export const batchBibliographyExportApi = new BatchBibliographyCollectionExportApi(
  config
)
export const batchBibliographyImportApi = new BatchBibliographyCollectionImportApi(
  config
)
export const batchTohanBooksOrderDataCreateApi = new BatchTohanBooksOrderDataCreateApi(
  config
)
export const batchTohanMarcRegApi = new BatchTohanMarcRegApi(config)
export const batchTrcBooksAndAvRegApi = new BatchTrcBooksAndAvRegApi(config)
export const batchTrcContentDetailRegisterApi = new BatchTrcContentDetailRegisterApi(
  config
)
export const batchTrcContentDetailUpdateApi = new BatchTrcContentDetailUpdateApi(
  config
)
export const batchTrcContentDataRegisterApi = new BatchTrcContentDataRegisterApi(
  config
)
export const batchTrcContentDataUpdateApi = new BatchTrcContentDataUpdateApi(
  config
)
export const batchTrcAuthorityRegisterApi = new BatchTrcAuthorityRegisterApi(
  config
)
export const batchTrcAuthorityUpdateApi = new BatchTrcAuthorityUpdateApi(config)
export const batchTrcBooksAndAvUpdateApi = new BatchTrcBooksAndAvUpdateApi(
  config
)
export const batchUserListApi = new BatchUserListApi(config)
export const batchUserRemovalApi = new BatchUserRemovalApi(config)
export const batchExpiredUserListApi = new BatchExpiredUserListApi(config)
export const batchDataShortageUserListApi = new BatchDataShortageUserListApi(
  config
)
export const batchTrcAcceptMarcRegisterApi = new BatchTrcAcceptMarcRegisterApi(
  config
)
export const batchTrcBooksOrderDataCreateApi = new BatchTrcBooksOrderDataCreateApi(
  config
)
export const bibliographyApi = new BibliographyApi(config)
export const bibliographyContentApi = new BibliographyContentApi(config)
export const bibliographyRealApi = new BibliographyRealApi(config)
export const bibliographySetApi = new BibliographySetApi(config)
export const budgetApi = new BudgetApi(config)
export const closedDayApi = new ClosedDayApi(config)
export const collectionApi = new CollectionApi(config)
export const conditionApi = new ConditionApi(config)
export const convertShelfTypeApi = new ConvertShelfTypeApi(config)
export const dataApi = new DataApi(config)
export const defaultParameterApi = new DefaultParameterApi(config)
export const donorApi = new DonorApi(config)
export const inspectionApi = new InspectionApi(config)
export const interLibraryLoanApi = new InterLibraryLoanApi(config)
export const jobApi = new JobApi(config)
export const lendApi = new LendApi(config)
export const logApi = new LogApi(config)
export const marcLabelApi = new MarcLabelApi(config)
export const myNoticeApi = new MyNoticeApi(config)
export const ndcListApi = new NdcListApi(config)
export const noticeApi = new NoticeApi(config)
export const orderApi = new OrderApi(config)
export const orderListApi = new OrderListApi(config)
export const patrolDayApi = new PatrolDayApi(config)
export const placeChangeApi = new PlaceChangeApi(config)
export const referenceApi = new ReferenceApi(config)
export const referenceImageMasterApi = new ReferenceImageMasterApi(config)
export const remindHistoriesApi = new RemindHistoriesApi(config)
export const reserveApi = new ReserveApi(config)
export const reserveGroupApi = new ReserveGroupApi(config)
export const reserveSetApi = new ReserveSetApi(config)
export const returnHistoriesApi = new ReturnHistoriesApi(config)
export const separateApi = new SeparateApi(config)
export const slideDaysApi = new SlideDaysApi(config)
export const systemBatchMenuApi = new SystemBatchMenuApi(config)
export const systemCodeAddressApi = new SystemCodeAddressApi(config)
export const systemCodeApi = new SystemCodeApi(config)
export const systemCodeAreaApi = new SystemCodeAreaApi(config)
export const systemCodeKeyApi = new SystemCodeKeyApi(config)
export const systemConfigApi = new SystemConfigApi(config)
export const systemGroupApi = new SystemGroupApi(config)
export const systemOperationMenuApi = new SystemOperationMenuApi(config)
export const systemParameterApi = new SystemParameterApi(config)
export const systemParameterKeyApi = new SystemParameterKeyApi(config)
export const systemTopMenuApi = new SystemTopMenuApi(config)
export const systemUserApi = new SystemUserApi(config)
export const systemUserLinkApi = new SystemUserLinkApi(config)
export const todayStatusApi = new TodayStatusApi(config)
export const traderAndDonorApi = new TraderAndDonorApi(config)
export const traderApi = new TraderApi(config)
export const uploadApi = new UploadApi(config)
export const usageStatisticsApi = new UsageStatisticsApi(config)
export const userApi = new UserApi(config)
export const collectionListApi = new CollectionListApi(config)
export const synonymGroupApi = new SynonymGroupApi(config)
export const separateDictionaryApi = new SeparateDictionaryApi(config)
export const systemCheckApi = new SystemCheckApi(config)
export const batchSchoolStatisticsApi = new BatchSchoolStatisticsApi(config)
export const batchSchoolStatisticsLendApi = new BatchSchoolStatisticsLendApi(
  config
)
export const batchSchoolStatisticsBestReaderApi = new BatchSchoolStatisticsBestReaderApi(
  config
)
export const batchSchoolLendCollectionListApi = new BatchSchoolLendCollectionListApi(
  config
)
export const batchSchoolUserListApi = new BatchSchoolUserListApi(config)
export const externalCollaborationApi = new ExternalCollaborationApi(config)
export const batchSchoolStatisticsAdvancementApi = new BatchSchoolStatisticsAdvancementApi(
  config
)
export const batchSchoolStatisticsNewStudentRegistrationApi = new BatchSchoolStatisticsNewStudentRegistrationApi(
  config
)
